import React from "react";
import logo from "../images/Playback Health Wordmark logo (1).svg";
import { sendMail } from "../../../helper/CommonFuncs";
import "./../trialUsers.css";

const withLayout = ({ children, showNeedHelp = true, removeMargin = false }) => {
   return (
      <div className="trial-new-flow-layout-container h-100 pop-in-v2">
         {/* Top Nav */}
         <nav
            className={` ${
               removeMargin ? "trial-new-flow-navbar-new-ui" : "trial-new-flow-navbar"
            } trial-new-flow-navbar`}
         >
            <div className="trial-new-flow-logo-wrapper">
               <img src={logo} alt="Logo" className="trial-new-flow-logo" />
            </div>
            {showNeedHelp && (
               <button
                  onClick={() => {
                     sendMail("support@playbackhealth.com");
                  }}
                  className="trial-new-flow-button"
               >
                  Need help?
               </button>
            )}
         </nav>

         {/* Page Content */}
         <div
            className={` ${showNeedHelp && !removeMargin && "margin-new-signup-flow-show-need-help"}  ${
               !removeMargin && "trial-new-flow-content"
            }`}
         >
            {children}
         </div>
      </div>
   );
};

export default withLayout;
